import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
var __default__ = {
  name: "SortableList",
  methods: {
    handleCancel: function handleCancel(e) {
      this.$emit("cancel", e);
    },
    handleSave: function handleSave(e) {
      this.isEdited = false;
      this.$emit("save", e);
    }
  }
};
import { ref, toRefs } from "vue"; // eslint-disable-next-line vue/valid-define-props

export default /*#__PURE__*/Object.assign(__default__, {
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    columnLabel: {
      type: String,
      default: ""
    },
    builtInCancelButton: {
      type: Boolean,
      default: true
    },
    builtInSaveButton: {
      type: Boolean,
      default: true
    },
    builtInEditButton: {
      type: Boolean,
      default: false
    },
    builtInEditLink: {
      type: String,
      default: ""
    }
  },
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var props = __props;

    var _toRefs = toRefs(props),
        items = _toRefs.items,
        columnLabel = _toRefs.columnLabel,
        builtInCancelButton = _toRefs.builtInCancelButton,
        builtInSaveButton = _toRefs.builtInSaveButton,
        builtInEditButton = _toRefs.builtInEditButton,
        builtInEditLink = _toRefs.builtInEditLink;

    var createIndexOrderItemList = function createIndexOrderItemList() {
      return items.value.sort(function (a, b) {
        return a.index < b.index ? -1 : a.index > b.index ? 1 : 0;
      });
    };

    var indexOrderItemList = ref(createIndexOrderItemList());
    var isEdited = ref(false);

    var changeOrderUp = function changeOrderUp(index) {
      isEdited.value = true;
      var sortIndex = indexOrderItemList.value[index].index;
      indexOrderItemList.value[index].index = indexOrderItemList.value[index - 1].index;
      indexOrderItemList.value[index - 1].index = sortIndex;
      indexOrderItemList.value.splice(index - 1, 2, indexOrderItemList.value[index], indexOrderItemList.value[index - 1]);
    };

    var changeOrderDown = function changeOrderDown(index) {
      isEdited.value = true;
      var sortIndex = indexOrderItemList.value[index].index;
      indexOrderItemList.value[index].index = indexOrderItemList.value[index + 1].index;
      indexOrderItemList.value[index + 1].index = sortIndex;
      indexOrderItemList.value.splice(index, 2, indexOrderItemList.value[index + 1], indexOrderItemList.value[index]);
    };

    expose({
      isEdited: isEdited
    });
    return {
      __sfc: true,
      props: props,
      items: items,
      columnLabel: columnLabel,
      builtInCancelButton: builtInCancelButton,
      builtInSaveButton: builtInSaveButton,
      builtInEditButton: builtInEditButton,
      builtInEditLink: builtInEditLink,
      createIndexOrderItemList: createIndexOrderItemList,
      indexOrderItemList: indexOrderItemList,
      isEdited: isEdited,
      changeOrderUp: changeOrderUp,
      changeOrderDown: changeOrderDown
    };
  }
});